module.exports = __webpack_public_path__ + "static/rainbow_jesus-27283fa02ab78bbd59c0a414793a1403.jpg";